// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6735":"a3eb23c166e5ee5a","6847":"811ec0a919898d11"}[chunkId] + ".js";
};